import React, { Fragment } from "react";
import { FaArrowLeft, FaCheckCircle, FaInfo, FaMoneyBillAlt } from "react-icons/fa";
import {
  Row,
  Col,
  Card,
  Button,
  Spinner,
  Alert,
  Form,
  Modal,
  Placeholder,
  InputGroup,
} from "react-bootstrap";
import { VscDesktopDownload } from "react-icons/vsc";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.bs5.css";
import BrtxSelect from "../../../componets/BrtxSelect";
import _props from "../../../componets/_params";

class RepairPriceList extends React.Component {
  timer = null;
  state = {
    alert: [],
    vendors: null,
    shop_name: null,
    loading: false,
    isLoading: false,
    data: [],
    data_vendors: [],
    data_type: [],
    data_list: [],
    detail_list: [],
    detail_DPH: 0,
    detailModal: false,
    timeoutId: null,
  };
  renderParams() {
    let cnt = 0;
    let text = "";
    if (this.state.vendors != null) {
      cnt > 0
        ? (text += "," + this.state.vendors.label)
        : (text = this.state.vendors.label);
      cnt++;
    }
    if (this.state.shop_name != null) {
      cnt > 0
        ? (text += "," + this.state.shop_name[0].label)
        : (text = this.state.shop_name[0].label);
      cnt++;
    }
    return <strong>{text}</strong>;
  }

  renderColor(color) {
    switch (color) {
      case ("bílá", "bíla"):
        return "#ffffff";
      case "černá":
        return "#000000";
      case "červená":
        return "#ff0000";
      case "šedá":
        return "#707070";
      case "fialová":
        return "#7400BF";
      case "růžová":
        return "#D6008B";
      case "hnědá":
        return "#5E3001";
      case "kovová":
        return "#C3C3C3";
      case "modrá":
        return "#1F22C4";
      case "béžová":
        return "#A68271";
      case "zelená":
        return "#14A73F";
      case "zlatá":
        return "#836309";
      case "purpurová":
        return "#FF0097";
      default:
        return "#ffffff";
    }
  }

  getVendors = async () => {
    this.setState({ loading: true });
    const _res = await this.props._api({
      ...this.props,
      method: "get",
      endpoint: "/api/Service/PriceList/v2/vendors",
      param: "",
      successText: ""
    });
    this.setState({ loading: false });
    if (_res.status == 200) {
      this.setState({ data_vendors: _res.data });
    }
  };

  getList = async (listid) => {
    this.setState({ loading: true });
    const _res = await this.props._api({
      ...this.props,
      method: "get",
      endpoint: "/api/Service/PriceList/v2/listId/" + listid,
      param: "",
      successText: ""
    });
    this.setState({ loading: false });
    if (_res.status == 200) {
      this.setState({
        data_list: _res.data,
        alert: [
          {
            type: "warning",
            text: "Ceny (náhradní díly + práce) jsou uvedeny s DPH bez dopravy. Ceny jsou pouze informativní. Konečnou cenu opravy vyčíslí technik po provedené kontrole popř. diagnostice zařízení.",
          },
        ],
      });
    }
  };

  componentDidMount() {
    this.props.setHeaderPage({
      Icon: <FaMoneyBillAlt className="c-placeholder c-green" />,
      Title: "Ceník nezáručních oprav",
      SubTitle: "",
      Buttons: <Button
      variant="outline-success me-4"
      onClick={() =>
        window.location.assign("https://api2.britex.cz/api/Global/Redirect/britexcz")
      }
    >
      <FaArrowLeft /> <strong> zpět na britex</strong>
    </Button>
    });
    this.props.noui(true);
    if (this.state.data_vendors.length == 0) this.getVendors();
    if (this.props.params.id != undefined) this.getList(this.props.params.id);
  }

  filterBy = () => true;

  getDetailList = async (id) => {
    this.setState({ loading: true, detailModal: true });
    const _res = await this.props._api({
      ...this.props,
      method: "get",
      endpoint: "/api/Service/PriceList/v2/detaillistid/" + id,
      param: "",
      successText: ""
    });
    this.setState({ loading: false });
    if (_res.status == 200) {
      let dph_sum = 0;
      {
        _res.data.map(i => {
          dph_sum += i.priceOW
        })
      }

      this.setState({ detail_list: _res.data, detail_DPH: ((dph_sum / 100) * 21) });
    }
  };

  getPriceList = async () => {
    this.setState({ loading: true });
    const _res = await this.props._api({
      ...this.props,
      method: "post",
      data: {
        vendor: this.state.vendors?.value,
        query: this.state.shop_name[0].value,
      },
      endpoint: "/api/Service/PriceList/v2/models",
      param: "",
      successText: ""
    });
    this.setState({ loading: false });
    if (_res.status == 200) {
      this.setState({ data: _res.data });
    }
  };

  handleSearch = (query) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      if (!this.state.isLoading) {
        this.setState({ isLoading: true });
        const _res = await this.props._api({
          ...this.props,
          method: "get",
          successText: "",
          endpoint:
            "/api/Service/PriceList/v2/shopname/" +
            this.state.vendors?.value +
            "/" +
            query,
          param: "",
        });
        this.setState({ isLoading: false });
        if (_res.status == 200) {
          this.setState({ data_type: _res.data });
        }
      }
    }, 1000);
  };

  render() {
    return (
      <>
        <Modal
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.detailModal}
          onHide={() => this.setState({ detailModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Položky opravy
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.detail_list.map((i, idx) => (
              <Card className="bg-uni mb-2">
                <Card.Body>
                  <Row>
                    <Col xs={8}>
                      <Row>
                        <strong>{i.itemCode}</strong>
                      </Row>
                      <Row>
                        <small className="text-muted">{i.itemName}</small>
                      </Row>
                    </Col>
                    <Col xs={2}>
                      <Row>
                        <small>Počet</small>
                      </Row>
                      <Row>
                        <strong>{i.quantity}</strong>
                      </Row>
                    </Col>
                    <Col xs={2}>
                      <Row>
                        <small>CZK</small>
                      </Row>
                      <Row>
                        <strong>{i.priceOW}</strong>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            ))}
            {!this.state.loading && (
              <Card className="bg-uni mb-2">
                <Card.Body>
                  <Row>
                    <Col xs={8}>
                      <Row>
                        <strong>DPH</strong>
                      </Row>
                      <Row>
                        <small className="text-muted">Daň</small>
                      </Row>
                    </Col>
                    <Col xs={2}>
                      <Row>
                        <small>Počet</small>
                      </Row>
                      <Row>
                        <strong>21%</strong>
                      </Row>
                    </Col>
                    <Col xs={2}>
                      <Row>
                        <small>CZK</small>
                      </Row>
                      <Row>
                        <strong>{Math.floor(this.state.detail_DPH * 100) / 100}</strong>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}
            {this.state.loading && (
              <Card className="bg-uni mb-2">
                <Card.Body>
                  <Row>
                    <Col xs={8}>
                      <Row>
                        <Placeholder animation="glow">
                          <Placeholder xs={8} />
                        </Placeholder>
                      </Row>
                      <Row>
                        <Placeholder animation="glow">
                          <Placeholder xs={8} />
                        </Placeholder>
                      </Row>
                    </Col>
                    <Col xs={2}>
                      <Row>
                        <Placeholder animation="glow">
                          <Placeholder xs={8} />
                        </Placeholder>
                      </Row>
                      <Row>
                        <Placeholder animation="glow">
                          <Placeholder xs={8} />
                        </Placeholder>
                      </Row>
                    </Col>
                    <Col xs={2}>
                      <Row>
                        <Placeholder animation="glow">
                          <Placeholder xs={8} />
                        </Placeholder>
                      </Row>
                      <Row>
                        <Placeholder animation="glow">
                          <Placeholder xs={8} />
                        </Placeholder>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}
          </Modal.Body>
        </Modal>
        <Card className="bg-uni mb-4">
          <Card.Body>
            {!this.state.loading && this.state.data.length == 0 && (
              <Row className="mb-4">
                <Col>
                  <Row>
                    <Col xs={11}>
                      <strong>Parametry hledání</strong>
                    </Col>
                    <Col xs={1} className="d-flex justify-content-end">
                      <Button variant="light" data-tip="Stáhnout celý ceník ve formátu XLSX">
                        <VscDesktopDownload className="fs-25" />
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
            {!this.state.loading && this.state.data.length == 0 && (
              <Row className="mb-4">
                <Col xs={12} lg={3}>
                  <BrtxSelect
                    placeholder="Vybrat výrobce"
                    options={this.state.data_vendors}
                    value={this.state.vendors}
                    onChange={(e) => this.setState({ vendors: e, data_type: [], shop_name: null })}
                  />
                  <Form.Text>Výrobce</Form.Text>
                </Col>
                <Col xs={12} lg={9}>
                  <InputGroup>
                    <AsyncTypeahead
                      id="shopName-searcher"
                      filterBy={this.filterBy}
                      isLoading={this.state.isLoading}
                      disabled={!this.state.vendors}
                      labelKey="label"
                      minLength={2}
                      selected={this.state.shop_name}
                      onChange={(e) => this.setState({ shop_name: e })}
                      onSearch={this.handleSearch}
                      options={this.state.data_type}
                      placeholder="Obchodní záev nebo typ přístroje..."
                      renderMenuItemChildren={(option, props) => (
                        <Fragment>
                          <span>{option.label}</span>
                        </Fragment>
                      )}
                    />
                    <FaInfo className="c-gray me-2" data-tip="Pro dohledání vašeho zařízení musíte vepsat alespoň 2 znaky do pole Obchodní název" />
                  </InputGroup>
                  <Form.Text>Typ přístroje / Obchodní název</Form.Text>
                </Col>
              </Row>
            )}

            <Row>
              <Col xs={10}>
                {!this.state.loading && this.state.data.length > 0 && (
                  <small>Použité parametry: {this.renderParams()}</small>
                )}
              </Col>
              <Col
                xs={2}
                className="d-flex justify-content-end align-items-center"
              >
                <Button
                  size="sm"
                  disabled={
                    this.state.loading ||
                    this.state.shop_name == null ||
                    this.state.shop_name?.length == 0
                  }
                  variant="success"
                  onClick={() => {
                    if (this.state.data.length > 0) {
                      this.setState({ data: [], data_list: [], alert: [], data_type: [], shop_name: null });
                      this.props.setNavigate("/repair/priceList");
                    }
                    if (this.state.data.length == 0) this.getPriceList();
                  }}
                >
                  {this.state.loading && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  {!this.state.loading && this.state.data.length == 0 && (
                    <>Vyhledat</>
                  )}
                  {!this.state.loading && this.state.data.length > 0 && (
                    <>Nové hledání</>
                  )}
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        {this.state.alert.map((i, idx) => (
          <Row className="mb-2">
            <Col xs={12}>
              <Alert variant={i.type}>{i.text}</Alert>
            </Col>
          </Row>
        ))}
        {this.state.data_list.length == 0 && (
          <>
            {this.state.data.map((i, idx) => (
              <Row className="mb-2">
                <Col xs={12}>
                  <Card
                    className="cursor-pointer"
                    onClick={() => this.getList(i.id)}
                  >
                    <Card.Body>
                      <Row>
                        <Col xs={4}>
                          <Row>
                            <strong>{this.state.vendors?.label}</strong>
                          </Row>
                          <Row>
                            <span>{i.typeName}</span>
                          </Row>
                        </Col>
                        <Col xs={5}>
                          <span className="text-muted">{i.shopName}</span>
                        </Col>
                        <Col xs={3} className="d-flex justify-content-end">
                          <div
                            className="pricelist-color"
                            title={i.color}
                            style={{
                              backgroundColor: this.renderColor(i.color),
                            }}
                          ></div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            ))}
          </>
        )}
        {this.state.data_list.length > 0 && (
          <>
            {this.state.data_list.map((i, idx) => (
              <Row className="mb-2">
                <Col xs={12}>
                  <Card
                    className="cursor-pointer"
                    onClick={() => this.getDetailList(i.id)}
                  >
                    <Card.Body>
                      <Row>
                        <Col xs={4}>
                          <Row>
                            <strong>{this.state.vendors?.label}</strong>
                          </Row>
                          <Row>
                            <span>{i.typeName}</span>
                          </Row>
                        </Col>
                        <Col xs={5}>
                          <Row>
                            <span className="text-muted">{i.shopName}</span>
                          </Row>
                          <Row>
                            <span>{i.spec}</span>
                          </Row>
                        </Col>
                        <Col xs={3} className="d-flex justify-content-end">
                          <Row>
                            <span className="text-muted">CZK&nbsp;</span>
                          </Row>
                          <Row>
                            <span>
                              <strong> {Math.floor(i.price * 1.21)}</strong>
                            </span>
                          </Row>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            ))}
          </>
        )}
      </>
    );
  }
}

export default _props(RepairPriceList);
